import React, { createContext, useEffect, useState } from 'react';

import { Alert, Device, Loadable } from '../types';
import { fetchDeviceAlerts } from '../api/services/deviceService';

interface DeviceAlertContextType {
  device?: Device;
  alerts: Loadable<Alert>;
  alertsInterval: number | undefined;
  setAlertsInterval: (interval: number | undefined) => void;
}

const loadableAlerts: Loadable<Alert> = { loading: true };

const initialContext: DeviceAlertContextType = {
  alerts: loadableAlerts,
  alertsInterval: undefined,
  setAlertsInterval: () => {},
};

const DeviceAlertContext = createContext<DeviceAlertContextType>(initialContext);

interface DeviceAlertProviderProps {
  device?: Device;
  children: React.ReactNode;
}

function DeviceAlertProvider({ device, children }: DeviceAlertProviderProps) {
  const [alerts, setAlerts] = useState<Loadable<Alert>>({ loading: true });
  const [alertsInterval, setAlertsInterval] = useState<number | undefined>();

  useEffect(() => {
    if (!device) return;

    // Load alerts
    setAlerts({ loading: true });
    const from = alertsInterval ? new Date(Date.now() - alertsInterval) : undefined;
    fetchDeviceAlerts(device.id, from)
      .then((data) => setAlerts({ loading: false, data }))
      .catch((err) => setAlerts({ loading: false, error: err }));
  }, [device, alertsInterval]);

  return (
    <DeviceAlertContext.Provider
      value={{
        device,
        alerts,
        alertsInterval,
        setAlertsInterval,
      }}
    >
      {children}
    </DeviceAlertContext.Provider>
  );
}

export { DeviceAlertContext, DeviceAlertProvider };
